import * as React from 'react';
import { useDispatch } from 'react-redux';
import globalSlice from '../store/auth.store';
import { PermissionProvider } from '@moovly/permissions';
import useAccess from '../hooks/useAccess';
interface LoggedInContainerProps {
  isAuthenticated: boolean;
  children: any;
}

const InitiateStoreContainer: React.FC<LoggedInContainerProps> = ({ isAuthenticated, children }) => {
  const dispatch = useDispatch<any>();
  const access = useAccess();
  React.useEffect(() => {
    dispatch(globalSlice.actions.isAuthenticated(isAuthenticated));
  }, [isAuthenticated, dispatch]);
  return <PermissionProvider scopes={access ? access.scopes : []}>{children}</PermissionProvider>;
};

export default InitiateStoreContainer;
